import * as Apollo from '@apollo/react-hooks'
import * as React from 'react'

import { useWhitelabel } from 'main/framework'
import { User_user } from 'main/gql/user'
import { Flags, useFeatureFlag } from 'main/hooks/useFeatureFlag'
import {
  familyChildrenPath,
  familyProgramsPath,
  familySchedulePath,
  messagesPath,
  myPasswordPath,
  mySavedSearchesPath,
} from 'main/routes'
import { DELETE_CREDENTIALS, logout } from 'main/util/auth'

import { LOCIZE_NAMESPACE } from 'main/common'
import { AssetName } from 'main/util/asset'
import { useTranslation } from 'react-i18next'
import SupportPhoneLink from '../SupportPhoneLink'
import Profile from './Profile'
import { ItemContainer, StyledLink, StyledNativeLink } from './styles'

interface IProps {
  user: User_user
}

const PRE = `COMPONENTS-MENU-PARENT`

function ParentMenu(props: IProps) {
  const { t } = useTranslation(LOCIZE_NAMESPACE)
  const { user } = props
  const {
    family: { children },
  } = user
  const whitelabel = useWhitelabel()
  const ssoFlag = useFeatureFlag(Flags.SSO)
  const isSSO = ssoFlag.enabled()

  const [deleteCredentials] = Apollo.useMutation(DELETE_CREDENTIALS, {
    onCompleted: () => handleCompleteLogout(isSSO),
  })
  const upeDisabled = !(window.lego && window.lego.upeEnabled)

  return (
    <ItemContainer>
      {upeDisabled && <Profile user={user} />}
      {upeDisabled && <StyledLink to={messagesPath()}>{t(`${PRE}-MESSAGES`)}</StyledLink>}
      {upeDisabled && (
        <StyledLink to={mySavedSearchesPath()}>{t(`${PRE}-SAVED-SEARCHES`)}</StyledLink>
      )}
      {upeDisabled && <StyledLink to={familyProgramsPath()}>{t(`${PRE}-MY-PROGRAMS`)}</StyledLink>}
      {upeDisabled && (
        <StyledLink to={familyChildrenPath()}>
          {children.length > 1 ? t(`${PRE}-MY-CHILDREN`) : t(`${PRE}-MY-CHILD`)}
        </StyledLink>
      )}
      {upeDisabled && <StyledLink to={familySchedulePath()}>{t(`${PRE}-SCHEDULE`)}</StyledLink>}
      {upeDisabled && (
        <StyledNativeLink href="/invoices">{t(`${PRE}-INVOICE-HISTORY`)}</StyledNativeLink>
      )}
      {upeDisabled && <StyledLink to="/payment_methods">{t(`${PRE}-PAYMENT-METHOD`)}</StyledLink>}
      {upeDisabled && <StyledLink to={myPasswordPath()}>{t(`${PRE}-MY-PASSWORD`)}</StyledLink>}
      {upeDisabled && whitelabel.showByDefaultExceptIfFalse(AssetName.START_A_WONDERSCHOOL) && (
        <StyledNativeLink href="/start">{t(`${PRE}-START-WONDERSCHOOL`)}</StyledNativeLink>
      )}
      <StyledNativeLink onClick={() => deleteCredentials()}>{t(`${PRE}-LOG-OUT`)}</StyledNativeLink>
      <SupportPhoneLink />
    </ItemContainer>
  )
}

function handleCompleteLogout(isSSO: boolean) {
  logout(isSSO)
}

export default React.memo(ParentMenu)
